import get from 'lodash/get';

import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import Progress from '../Components/Progress/Progress';

const mapStateToProps = (state) => ({
  Component: Progress,
  loading: get(state, 'ui.visibilityMap.globalLoader', false)
        || get(state, 'ui.visibilityMap.loadVisualization', false),
});

export default containerConnect(mapStateToProps);
